var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"node-hover-onboarding-controls-add-section"},[_c('button',{staticClass:"node-hover-onboarding-controls-buttons__button",on:{"click":_vm.addSection}},[_c('Icon',{attrs:{"icon":"PlusIconSolid","size":"14"}}),_vm._v(" Add Section ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }